module.exports = __webpack_public_path__ + "img/图片12.83ac5d9b.png";